import { toLower } from 'lodash'

/**
 * Extracts the current page name from MUI breadcrumbs
 */
const getFormattedBreadcrumbPath = (param): string => {
  const breadcrumbItems = Array.from(document.querySelectorAll('li.MuiBreadcrumbs-li'))

  if (breadcrumbItems.length === 0) {
    return param
  }

  const breadcrumText = breadcrumbItems
    .map(
      li =>
        (li.textContent ?? '')
          .replace(/[-_.]/g, '_') // Substitui - . e _ por _
          .replace(/__+/g, '_') // Remove múltiplos _ consecutivos
          .replace(/\s+/g, '_'), // Remove espaços em branco
    )
    .filter(Boolean)
    .join('_')
  return toLower(breadcrumText)
}

export { getFormattedBreadcrumbPath }
